/* eslint-disable react-hooks/exhaustive-deps */
import { BigDecimal } from "@pcgerente-node/pcg-comun";
import React from "react";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";

const ResultadoDetalles: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({guia}) => {
    return (
             <div className="invoice-detail-total">
                <div className="row">

                    <div className="col-sm-5 col-12 order-sm-1 order-0">
                        <div className="text-sm-right">
                            <div className="row">
                                <div className="col-sm-5 col-5">
                                    <p className="">Base Iva 12%: </p>
                                </div>
                                <div className="col-sm-4 col-5">
                                    <p className="">${new BigDecimal(guia.baseIva||0).toFixed(2)}</p>
                                </div>
                                <div className="col-sm-5 col-5">
                                    <p className="">Base Iva 0%: </p>
                                </div>
                                <div className="col-sm-4 col-5">
                                    <p className="">${new BigDecimal(guia.baseCero||0).toFixed(2)}</p>
                                </div>
                                <div className="col-sm-5 col-5">
                                    <p className=" discount-rate">Iva 12%:</p>
                                </div>
                                <div className="col-sm-4 col-5">
                                    <p className="">${new BigDecimal(guia.iva||0).toFixed(2)}</p>
                                </div>
                                <div className="col-sm-5 col-5 grand-total-title">
                                    <h4 className="">Total : </h4>
                                </div>
                                <div className="col-sm-4 col-5 grand-total-amount">
                                    <h4 className="">${new BigDecimal(guia.total||0).toFixed(2)}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )

    
}
export default ResultadoDetalles